import React, { useState, useEffect, useCallback } from 'react';
import {
    HashRouter,
    Routes,
    Route,
    useNavigate,
    Navigate,
} from 'react-router-dom';
import { Mail,Link,LogOut, LayoutDashboard, User, AlertTriangle, LogIn, Loader2, RefreshCw, Home, Zap, ShoppingBag, Settings, CreditCard, ArrowLeft } from 'lucide-react';
import blurTop from '../../assets/splashScreen/Blur.svg'
import { API_BASE_URL } from '../../config/api';


// function ForgotPasswordPage() {
    
//     const navigate = useNavigate();
//     // Use the API URL provided by the user
//     const API_URL = "https://psh-admin.zolute.xyz/api/auth/reset-password";

//     const [email, setEmail] = useState('');
//     const [isLoading, setIsLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [message, setMessage] = useState(null);

//     const handleChange = (e) => {
//         setEmail(e.target.value);
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setError(null);
//         setMessage(null);
//         setIsLoading(true);

//         try {
//             const payload = { email: email };

//             const response = await fetch(API_URL, {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify(payload),
//             });

//             const result = await response.json();

//             if (response.ok && (result.status === 'SUCCESS' || result.message?.includes('sent'))) {
//                 setMessage('A password reset link has been successfully sent to your email.');
//                 // Optionally navigate back to signin after a delay
//                 // setTimeout(() => navigate('/signin'), 3000); 
//             } else {
//                 const errorMessage = result.message || JSON.stringify(result.errors || result) || 'Failed to send reset email.';
//                 setError(errorMessage);
//             }
//         } catch (err) {
//             setError('Network error or server unreachable. Please check the API URL.');
//         } finally {
//             setIsLoading(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden max-w-md mx-auto">
//             <img
//                 src={blurTop}
//                 alt="Decorative background blur"
//                 className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
//                 style={{ zIndex: 0 }}
//             />

//             <div className="relative z-10 flex flex-col h-full">
                
//                 <div className="flex items-center mb-8">
//                     <button 
//                         onClick={() => navigate('/signin')}
//                         className="p-2 mr-2 rounded-full hover:bg-gray-100 transition text-gray-600"
//                         aria-label="Back to Sign In"
//                     >
//                         <ArrowLeft className="w-5 h-5" />
//                     </button>
//                     <h1 className="text-3xl font-bold text-[#307CF8]">Reset Password</h1>
//                 </div>

//                 <p className="text-gray-500 text-sm mt-1 mb-6">
//                     Enter your email to receive a password reset link.
//                 </p>
                
//                 {error && (
//                     <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-xl flex items-start text-sm mb-4">
//                         <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
//                         <p className="font-medium">Error: {error}</p>
//                     </div>
//                 )}
                
//                 {message && (
//                     <div className="mt-4 p-3 bg-green-100 border border-green-400 text-green-700 rounded-xl flex items-start text-sm mb-4">
//                         <p className="font-medium">{message}</p>
//                     </div>
//                 )}

//                 <form className="space-y-6 flex-1 flex flex-col justify-center" onSubmit={handleSubmit}>
//                     <div>
//                         <label className="text-gray-600 text-sm">Email Address</label>
//                         <input
//                             type="email"
//                             name="email"
//                             value={email}
//                             onChange={handleChange}
//                             placeholder="name@email.com"
//                             required
//                             disabled={isLoading || !!message}
//                             className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition disabled:bg-gray-50 disabled:cursor-not-allowed"
//                         />
//                     </div>

//                     <button 
//                         type="submit"
//                         className={`w-full py-3 rounded-xl font-semibold text-white mt-10 shadow-lg transition flex items-center justify-center ${
//                             isLoading || !!message ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/50'
//                         }`}
//                         disabled={isLoading || !!message}
//                     >
//                         {isLoading ? (
//                             <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Sending Request...</>
//                         ) : (
//                             'Send Reset Link'
//                         )}
//                     </button>
//                 </form>

//                 <p className="text-center text-gray-600 text-sm mt-auto pt-6">
//                     Remember your password?{" "}
//                     <span 
//                         className="text-blue-600 font-semibold cursor-pointer hover:underline"
//                         onClick={() => navigate("/signin")}
//                     >
//                         Sign in
//                     </span>
//                 </p>
//             </div>
//         </div>
//     );
// }
function ForgotPasswordPage() {
    
    const navigate = useNavigate();
    // Use the API URL provided by the user
    const API_URL = `${API_BASE_URL}/auth/reset-password`;

    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    // State to hold the success response data (token, url, email)
    const [successData, setSuccessData] = useState(null); 

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccessData(null);
        setIsLoading(true);

        try {
            const payload = { email: email };

            const response = await fetch(API_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
            });

            const result = await response.json();

            // Check for a successful response and the expected fields (token/url)
            if (response.ok && result.url && result.email) {
                // If successful, store the response data
                setSuccessData(result);
            } else {
                const errorMessage = result.message || JSON.stringify(result.errors || result) || 'Failed to send reset email. Please try again.';
                setError(errorMessage);
            }
        } catch (err) {
            setError('Network error or server unreachable. Please check the API URL.');
        } finally {
            setIsLoading(false);
        }
    };

    // If successData is present, show the confirmation screen
    if (successData) {
        return (
            <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden max-w-md mx-auto font-sans">
                 <div className="relative z-10 flex flex-col items-center justify-center text-center h-full flex-1">
                    <Mail className="w-16 h-16 text-green-500 mb-6"/>
                    <h1 className="text-3xl font-bold text-green-600 mb-4">Email Sent!</h1>
                    <p className="text-gray-600 mb-8">
                        A password reset link has been successfully sent to:
                        <br/>
                        <strong className="text-blue-600 break-all">{successData.email}</strong>
                    </p>
                    
                    <div className="bg-gray-100 p-4 rounded-xl w-full text-left break-words shadow-inner">
                        <p className="text-sm font-semibold text-gray-700 flex items-center mb-2">
                           <Link className="w-4 h-4 mr-2 text-gray-500"/> Reset Link URL:
                        </p>
                        <p className="text-xs text-gray-600 break-all">
                            {successData.url}
                        </p>
                    </div>

                    <button 
                        onClick={() => navigate('/signin')}
                        className="w-full py-3 rounded-xl font-semibold text-white mt-10 bg-blue-600 hover:bg-blue-700 shadow-lg transition shadow-blue-500/50"
                    >
                        Back to Sign In
                    </button>
                </div>
            </div>
        );
    }
    
    // Default form view
    return (
        <div className="min-h-screen bg-white text-gray-800 px-6 py-10 flex flex-col relative overflow-hidden max-w-md mx-auto font-sans">
            <img
                src={blurTop}
                alt="Decorative background blur"
                className="absolute top-0 left-0 w-full h-auto pointer-events-none select-none opacity-40"
                style={{ zIndex: 0 }}
            />

            <div className="relative z-10 flex flex-col h-full">
                
                <div className="flex items-center mb-8">
                    <button 
                        onClick={() => navigate('/signin')}
                        className="p-2 mr-2 rounded-full hover:bg-gray-100 transition text-gray-600"
                        aria-label="Back to Sign In"
                    >
                        <ArrowLeft className="w-5 h-5" />
                    </button>
                    <h1 className="text-3xl font-bold text-[#307CF8]">Reset Password</h1>
                </div>

                <p className="text-gray-500 text-sm mt-1 mb-6">
                    Enter your email address to request a new password.
                </p>
                
                {error && (
                    <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-xl flex items-start text-sm mb-4">
                        <AlertTriangle className="w-5 h-5 mr-2 flex-shrink-0 mt-0.5" />
                        <p className="font-medium">Error: {error}</p>
                    </div>
                )}

                <form className="space-y-6 flex-1 flex flex-col justify-center" onSubmit={handleSubmit}>
                    <div>
                        <label className="text-gray-600 text-sm">Email Address</label>
                        <input
                            type="email"
                            name="email"
                            value={email}
                            onChange={handleChange}
                            placeholder="name@email.com"
                            required
                            disabled={isLoading}
                            className="mt-1 w-full px-4 py-3 rounded-xl bg-white text-gray-800 border border-gray-300 focus:border-blue-600 outline-none placeholder:text-gray-400 shadow-sm transition disabled:bg-gray-50 disabled:cursor-not-allowed"
                        />
                    </div>

                    <button 
                        type="submit"
                        className={`w-full py-3 rounded-xl font-semibold text-white mt-10 shadow-lg transition flex items-center justify-center ${
                            isLoading ? 'bg-blue-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 shadow-blue-500/50'
                        }`}
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <><Loader2 className="w-5 h-5 mr-2 animate-spin" /> Sending Request...</>
                        ) : (
                            'Send Reset Link'
                        )}
                    </button>
                </form>

                <p className="text-center text-gray-600 text-sm mt-auto pt-6">
                    Remember your password?{" "}
                    <span 
                        className="text-blue-600 font-semibold cursor-pointer hover:underline"
                        onClick={() => navigate("/signin")}
                    >
                        Sign in
                    </span>
                </p>
            </div>
        </div>
    );
}


export default ForgotPasswordPage
